import React from 'react';
import { DeleteConfirmModal } from '../../../components/generic/DeleteConfirmModal';
import { createModal } from '../../../components/generic/Modal';
import { useAppContext } from '../../../hooks/useAppContext';

interface Props {
  onDelete: () => void;
}

export const TemplateScoringChecklistDeleteModal = createModal<Props>((props) => {
  const { onDelete, modal } = props;
  const { successToast } = useAppContext();

  const onDeletePrime = React.useCallback(async () => {
    onDelete();
    successToast('Scoring checklist deleted successfully');
  }, [onDelete, successToast]);

  return (
    <DeleteConfirmModal
      modal={modal}
      heading='Do you want to delete this scoring checklist?'
      confirmation={{ level: 'Level2', confirm: 'DELETE' }}
      onDelete={onDeletePrime}
    />
  );
});
